import gql from 'graphql-tag';

const optOutOnboardingQueueGroupMutation = gql`
  mutation OptOutOnboardingQueueGroup($input: OptOutOnboardingQueueGroupInput!) {
    optOutOnboardingQueueGroup(input: $input) {
      success
      errors
      onboardingQueueGroupAction {
        totalCount
        successCount
        skippedCount
        failureCount
        results {
          flatRateOfferId
          dealer5Mil
          outcome
          success
          status
          message
        }
      }
    }
  }
`;

export default optOutOnboardingQueueGroupMutation;
